module.exports = __webpack_public_path__ + "img/separateur.4233c1a3.svg";